import type { StateCreator } from "zustand"

import type { AppState, BeatGridSlice } from "@/store/types"

export const createBeatGridSlice: StateCreator<
  AppState,
  [],
  [],
  BeatGridSlice
> = (set) => ({
  beatGrid: null,
  gridStatus: "idle",
  gridError: null,
  setBeatGrid: (beatGrid) =>
    set({ beatGrid, gridStatus: "done", gridError: null }),
  clearBeatGrid: () =>
    set({ beatGrid: null, gridStatus: "idle", gridError: null }),
  setGridStatus: (gridStatus, gridError = null) =>
    set({ gridStatus, gridError }),
})
